module.exports = __webpack_public_path__ + "static/smi4Mini-3c809b45c1761b0bf5706caa8d47b57c.png";